export default __webpack_public_path__ + "static/media/Clicked.808d140a.svg";